export { default } from "./Avatar.js";
export { default as avatarClasses } from "./avatarClasses.js";
export * from "./avatarClasses.js";